export const AWS_MARKETPLACE_URL = 'https://aws.amazon.com/marketplace/pp/prodview-jbay5iyfmu6ui';
export const NO_CACHE_HEADER = { 'X-Cache-Control': 'max-age=0' };
export const AGENT_TROUBLESHOOTING_GUIDE_URL = 'https://docs.netapp.com/us-en/console-setup-admin/task-troubleshoot-agent.html#common-error-messages-and-resolutions';
export const DEFAULT_TABLE_PAGE_SIZE = 50;
export const DEFAULT_AUTO_REFRESH_INTERVAL = 60000;